export default __webpack_public_path__ + "static/media/factory.2d0d67a7.png";